import sx from '../../sx.js';
import { themeGet } from '../../utils/theme-get.js';
import React__default from 'react';
import styled, { keyframes } from 'styled-components';
import Box from '../Box/Box.js';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SIZES = {
  xsmall: '8px',
  small: '16px',
  medium: '24px',
  large: '48px',
  xlarge: '96px'
};
const rotateKeyframes = keyframes(["100%{transform:rotate(360deg);}"]);
const Wrapper = styled(Box).withConfig({
  displayName: "Spinner__Wrapper",
  componentId: "sc-rcpg8b-0"
})(["animation:", " 0.86s infinite;animation-timing-function:cubic-bezier(0.4,0.15,0.6,0.85);transform-origin:center;"], rotateKeyframes);
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */
const loadIn = keyframes(["from{transform:'rotate(50deg)';opacity:0;stroke-dashoffset:60}to{transform:'rotate(230deg)';opacity:1;stroke-dashoffset:50}"]);
const StyledTracklessSVG = styled.svg.withConfig({
  displayName: "Spinner__StyledTracklessSVG",
  componentId: "sc-rcpg8b-1"
})(["animation:", " 1s ease-in-out;animation-fill-mode:forwards;opacity:0;"], loadIn);
const Circle = styled.circle.withConfig({
  displayName: "Spinner__Circle",
  componentId: "sc-rcpg8b-2"
})(["fill:none;stroke-dasharray:60;stroke-dashoffset:inherit;stroke-linecap:round;stroke-width:1.5;@media screen and (forced-colors:active){filter:grayscale(100%);stroke:CanvasText;}stroke:", ";", ""], p => p.appearance === 'inherit' ? themeGet('colors.text.subtle') : themeGet('colors.text.inverse'), sx);
const Spinner = ({
  size: sizeKey = 'medium',
  testId,
  delay,
  'aria-label': ariaLabel,
  'aria-labelledby': ariaLabelledBy,
  appearance = 'inherit',
  sx: sxProp,
  ...props
}) => {
  const size = typeof sizeKey === 'number' ? sizeKey : SIZES[sizeKey];
  if (!ariaLabel && !ariaLabelledBy) {
    console.warn('Please add an aria-label or aria-labelledby attribute to Spinner for accessibility. See https://www.fuegokit.design/react/components/spinner#accessibility');
  }
  return /*#__PURE__*/React__default.createElement(Wrapper, {
    as: "span",
    sx: {
      display: 'inline-flex',
      verticalAlign: 'middle',
      width: size,
      height: size
    },
    "data-testid": testId ? `${testId}-spinner-wrapper` : undefined
  }, /*#__PURE__*/React__default.createElement(StyledTracklessSVG, _extends({
    height: size,
    width: size,
    viewBox: "0 0 16 16",
    "data-testid": testId ? `${testId}-spinner-svg` : undefined,
    "aria-label": ariaLabel || undefined,
    "aria-labelledby": ariaLabelledBy || undefined
  }, props), /*#__PURE__*/React__default.createElement(Circle, {
    cx: "8",
    cy: "8",
    r: "7",
    appearance: appearance,
    sx: sxProp
  })));
};
Spinner.displayName = "Spinner";
const StyledSpinner = styled(Spinner).withConfig({
  displayName: "Spinner__StyledSpinner",
  componentId: "sc-rcpg8b-3"
})(["", ""], sx);
StyledSpinner.displayName = 'Spinner';
var Spinner$1 = StyledSpinner;

export { Spinner$1 as default };
